import {
  Component,
  ContentChild,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
  TemplateRef,
} from '@angular/core';
import { EngagementMetric } from 'src/app/core/data-models/engagement-metric';
import { GlobalsService } from 'src/app/core/services/globals.service';
import { LanguageService } from 'src/app/core/services/language.service';
import {
  ChildrenAnimation,
  listAnimation,
} from '../../shared/animations/allAnimations';
import { ModuleName } from '../enums/ModuleName';
import {
  ZenSnackbarService,
  ZenSnackBarTypes,
} from '../Theme/services/zen-snackbar.service';
import { TranslatePipe } from '../pipes/translate.pipe';
import { Engagement } from 'src/app/core/data-models/engagement';
import { PlatformUser } from '@ex/module/core/data-models/platform-user';
import { BaseComponent } from '@ex/module/core/domain/base-component';
import { filter } from 'rxjs/operators';
import { PushidService } from '@ex/module/core/services/pushid.service';

@Component({
  selector: 'select-criteria',
  templateUrl: './criteria.component.html',
  styleUrls: ['./criteria.component.scss'],
  animations: [ChildrenAnimation, listAnimation],
})
export class CriteriaComponent extends BaseComponent implements OnInit {
  pushIdService = inject(PushidService);
  user: PlatformUser;
  constructor(
    private languageService: LanguageService,
    private _globals: GlobalsService,
    private zenSnackBarService: ZenSnackbarService,
    private translationPipe: TranslatePipe
  ) {
    super();
    this.hugeCount = _globals.hugeCount;
    this.lgCount = _globals.lgCount;
    this.mdCount = _globals.mdCount;
    this.smCount = _globals.smCount;
    const data$ = this.EssentialObject$.pipe(filter(x => x?.user?.key != null)).subscribe(x => {
      this.user = x.user;
    });
    this.addSubscription(data$);
  }
  @ContentChild(TemplateRef) header: TemplateRef<any>;
  ModuleNames = ModuleName;
  criteriaList;
  criteria: boolean = true;
  invalid: boolean = false;
  loading: boolean = false;
  criteriaAdd;
  newMetric: EngagementMetric;
  vMetricName;
  vMetricOptions;
  hugeCount;
  lgCount;
  edited;
  mdCount;
  smCount;
  deselectConfirmation: boolean = false

  @Input() softDelete: boolean = false;
  @Input('engagement') survey: Engagement;
  @Output('engagementChange') surveyChange: EventEmitter<Engagement> = new EventEmitter();

  @Input('language') language;
  @Input() selection: boolean = true;
  @Input('selectedEntity') selectedEntity;
  @Input('matrixList') set list(criterias: EngagementMetric[]) {
    if (!criterias?.length)
      return;
    if (!this.criteriaList?.length)
      this.criteriaList = criterias;
    this.criteriaList?.map(criteria => {
      if (this.engagementMetrics?.find(x => x.key == criteria.key)) {
        criteria.isSelected = true;
      }
    })
    this.txtWrongTextCount = this.translationPipe.transform(
      'txt_wrong_text_count',
      this.language,
      this.ModuleNames.Shared
    );
    this.txtFillFields = this.translationPipe.transform(
      'txt_fill_fields',
      this.language,
      this.ModuleNames.Shared
    );
    this.txtMinimumTwoOptions = this.translationPipe.transform(
      'txtMinimumTwoOptions',
      this.language,
      this.ModuleNames.Shared
    );


    this.loading = false;
    // this.survey.predefinedMetrics = true;
  }
  txtMinimumTwoOptions;
  txtFillFields;
  txtWrongTextCount;
  @Input('modal') set modal(open) {
    if (open) this.criteriaAddFunction();
    else this.criteriaAdd = false;;
  }
  @Output() modalChange = new EventEmitter();
  engagementMetrics;
  @Input('engagementMetrics') set metrics(engagementMetrics) {
    if (!this.engagementMetrics?.length)
      this.engagementMetrics = engagementMetrics;

    this.criteriaList?.map(criteria => {
      if (this.engagementMetrics?.find(x => x.key == criteria.key)) {
        criteria.isSelected = true;
      }
    })

    // this.engagementMetrics = this.engagementMetrics.filter(x => engagementMetrics.find(y => y.key == x.key));
  }
  @Output('updateEngagementMetrics') updateEngagementMetrics =
    new EventEmitter();

  @Input() tourKey;
  @Input() tourRespondednt;
  answerIncreaseClick() {
    if (!this.newMetric.options) this.newMetric.options = [];

    let option = { key: this.pushIdService.generatePushId(), name: [] };
    this.newMetric.options.push(option);
  }
  deleteOption(option) {
    const index = this.newMetric.options.indexOf(option);
    if (!this.softDelete) {
      this.selectedEntity.JobGrades[index].isDeleted = true;
      this.selectedEntity.JobGrades[index].deletedBy = this.user.firstName + ' ' + this.user.lastName;
      this.selectedEntity.JobGrades[index].deletionDate = new Date().toString();
    }
    else this.newMetric.options.splice(index, 1);

  }

  criteriaToDelete = null

  deleteCriteria(criteria) {
    this.updateEngagementMetrics.emit({
      metric: criteria,
      tKey: this.criteriaList.indexOf(criteria),
    });
    
    this.criteriaToDelete = null
  }

  ngOnInit(): void {
    console.log(this.tourKey);
  }

  selectCriteria(criteria) {
    if (criteria.key == "DirectManagerId") {
      if (criteria.isSelected)
        this.deselectConfirmation = true
      else
        criteria.isSelected = true
    } else {
      criteria.isSelected = !criteria.isSelected;
    }
  }
  deselectDirectManager() {
    this.criteriaList.forEach((e) => {
      if (e.key == 'DirectManagerId') e.isSelected = false;
    })
    this.deselectConfirmation = false
  }
  // localize(key: string) {
  //   return this.languageService.getUILanguage(key, this.language);
  // }
  extractNameLanguage(eG: any) {
    return this.languageService.extractNameLanguage(eG, this.language);
  }
  criteriaIsSelected(criteria) {
    return !!criteria.isSelected;
  }
  logData(e) {
    console.log(e);
  }
  criteriaAddFunction(criteria?) {
    this.criteriaAdd = true;
    this.invalid = false;
    if (!criteria) {
      this.edited = false;
      this.newMetric = new EngagementMetric();
      this.newMetric.key = this.pushIdService.generatePushId();
      this.newMetric.isCustom = true;
      this.answerIncreaseClick();
    } else {
      this.edited = true;
      this.newMetric = criteria;
    }
  }
  criteriaAddExisting(key, criteria) {
    this.newMetric = new EngagementMetric();
    this.newMetric = criteria;
    this.newMetric.key = key;
    this.newMetric.isEntity = true;

    this.updateEngagementMetrics.emit(this.newMetric);
  }
  duplicatedCriteria(criteria) {
    this.engagementMetrics.forEach((element) => {
      return element.name[0].name != criteria.name[0].name;
    });
    //
  }

  countWord(word, count) {
    if (word?.length <= count) return word.length;
    if (word?.length > count) {
      return word.length;
    }
  }
  updateSelectedMetrics(engagementMetric, x) {
    this.loading = true;
    if (!this.engagementMetrics?.find((mt) => mt.key == engagementMetric.key)) {
      this.updateEngagementMetrics.emit(engagementMetric);
    } else {
      this.updateEngagementMetrics.emit({ metric: engagementMetric, tKey: x });
    }
  }
  validateCriteria(engagementMetric: EngagementMetric) {
    let isValid: boolean = true;
    let duplicateOptionText = '';

    // Sanitize text
    if (Array.isArray(engagementMetric.name)) {
      engagementMetric.name.forEach((t: any) => { if (t.name) t.name = t.name.trim(); });
    }
    if (engagementMetric.options) {
      engagementMetric.options.forEach(opt => {
        if (Array.isArray(opt.name)) {
          opt.name.forEach((t: any) => { if (t.name) t.name = t.name.trim(); });
        }
      });
    }

    if (
      engagementMetric.name.filter((d: any) => d.name == '' || d.name == null).length ==
      engagementMetric.name.length
    ) {
      this.vMetricName = true;
      isValid = false;
    } else {
      this.vMetricName = false;
    }
    console.log(engagementMetric.options?.length);

    if (
      engagementMetric.options.length < 2 ||
      !engagementMetric.options?.length
    ) {
      this.zenSnackBarService.snackBar({
        message: this.txtMinimumTwoOptions,
        type: ZenSnackBarTypes.Error,
      });
      return (isValid = false);
    }

    for (let i = 0; i < engagementMetric.options?.length; i++) {
      let option = engagementMetric.options[i];
      let currentText = this.extractNameLanguage(option.name);

      if (currentText == '') {
        isValid = false;
      }
      if (!this.validateCount(option.name, this.mdCount)) return false;

      // Duplicate Check
      if (currentText && currentText !== '') {
        for (let j = i + 1; j < engagementMetric.options?.length; j++) {
          let compareText = this.extractNameLanguage(engagementMetric.options[j].name);
          if (currentText.toLowerCase() === compareText.toLowerCase()) {
            duplicateOptionText = currentText;
            break;
          }
        }
      }
      if (duplicateOptionText) break;
    }

    if (duplicateOptionText) {
      this.zenSnackBarService.snackBar({
        message: this.translationPipe.transform('txt_duplicate_options_error', this.language, this.ModuleNames.Shared) || "Duplicate options are not allowed.",
        type: ZenSnackBarTypes.Error,
      });
      return false;
    }

    if (!isValid)
      this.zenSnackBarService.snackBar({
        message: this.txtFillFields,
        type: ZenSnackBarTypes.Error,
      });

    if (!this.validateCount(engagementMetric.name, this.mdCount, 'x')) return;

    return isValid;
  }

  validateCount(value, count, ready?) {
    let validatedCount;
    if (ready == 'x') {
      validatedCount = this.countWord(value, count);
    } else
      validatedCount = this.countWord(this.extractNameLanguage(value), count);
    if (validatedCount > count) {
      this.zenSnackBarService.snackBar({
        message: this.txtWrongTextCount,
        type: ZenSnackBarTypes.Error,
      });
      return false;
    }
    if (validatedCount <= count) {
      return true;
    }
  }
  updateMetric(newMetric) {
    this.invalid = true;
    if (this.validateCriteria(newMetric)) {
      this.updateEngagementMetrics.emit(newMetric);
      this.criteriaAdd = false;
      this.modalChange.emit(false);
    }
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.criteriaList;
    const newCriterias = this.criteriaList.filter(criteria => criteria.isSelected && !this.engagementMetrics?.find(x => x.key == criteria.key));
    const deletedCriterias = this.criteriaList.filter(criteria => !criteria.isSelected && this.engagementMetrics?.find(x => x.key == criteria.key));
    [...newCriterias, ...deletedCriterias].forEach(criteria => {
      const index = this.criteriaList.indexOf(criteria);
      this.updateSelectedMetrics(criteria, index);
    })
  }
}
